<template>
  <div class="layout">
    <div class="ui-con">
      <div>
        <img @click="$router.push({path:'/'})" class="logo" :src="`${$cdn}images/k.png`" alt />
      </div>
      <div class="search-con" @click="$router.push({path:'/search'})">
        <input :placeholder="$route.query.keyword" disabled type="text" />
        <img :src="`${$cdn}images/s-search.png`" alt />
      </div>
      <ul class="txt-con" v-if="!isMobile">
        <li @click="gotoResult(item)" v-for="(item,i) in keyword" :key="i">{{item}}</li>
      </ul>
      <template v-if="list.length>0">
        <div class="l-con">
          <Card @handleItem="handleItem(item)" v-for="(item, i) in list" :item="item" :key="i" />
        </div>
        <div class="paging" :class="{ pagingshow: total }" v-if="!isMobile">
          <Paging
            @clickHandle="pageChange"
            :current="currentPage"
            :total="total"
            :equable="pageSize"
          />
        </div>
      </template>
      <template v-else>
        <div class="no-result">
          <img :src="`${$cdn}images/search-icon.png`" alt />
          <span>暂时没有内容呢~请搜索其他关键词吧</span>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import browser from "@/utils/browser.js";
import Card from "@/components/card";
import Paging from "@/components/paging";

let keyword = [
  "西楼外立面",
  "东楼",
  "铁栏杆",
  "体育室木护壁"
];

export default {
  data() {
    return {
      isMobile: browser.mobile,
      keyword,
      active: "体育室木护壁",
      list:[],
      total: 0,
      pageSize: 8,
      currentPage: 1
    };
  },
  methods: {
    pageChange(num) {
      this.currentPage = num
    },
    handleItem(){
      this.$router.push({
        name:'Parts',
        query:{
          block: '',
          typeId: '',
          zone: '',
          searchKey:this.$route.query.keyword
        }
      })
    },
    gotoResult(item = "") {
      this.$router.push({
        name: "Result",
        query: {
          keyword: item
        }
      });
    },
    async getList(keyword = '') {
      let res = await this.$http({
        method: "post",
        data: {
          block: "",
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          searchKey: keyword,
          typeId: "",
          zone: ""
        },
        url: `/api/web/part/list`
      });
      this.list = res.data.list;
      this.total = res.data.total;
    }
  },
  watch: {
    "$route.query": function(newVal) {
      this.getList(newVal)
    },
    currentPage(){
      this.getList(this.$route.query.keyword)
    }
  },
  mounted(){
      this.getList(this.$route.query.keyword)
  },
  components: {
    Card,
    Paging
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/globalVars.less";

input::placeholder {
  color: @theme !important;
}

.layout {
  width: calc(100% - 200px);
  position: relative;
  .ui-con {
    width: 100%;
    padding-top: 60px;
    text-align: center;
    .logo {
      width: 340px;
    }
    .search-con {
      border: 2px solid @theme;
      border-radius: 28px;
      width: 560px;
      margin: 20px auto;
      position: relative;
      padding-left: 0px;
      background: rgba(0, 0, 0, 0.05);
      cursor: pointer;
      input {
        border: none;
        background: none;
        line-height: @inputH;
        height: @inputH;
        width: 94%;
        vertical-align: middle;
        color: @theme;
      }
      img {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 6px;
      }
    }
    .txt-con {
      margin-bottom: 20px;
      width: 80%;
      margin: 0 auto;
      li {
        font-size: 14px;
        display: inline-block;
        padding: 4px 14px;
        position: relative;
        cursor: pointer;
        &:hover {
          background: @theme;
          color: #c9a27b;
          position: relative;
          &::after {
            position: absolute;
            bottom: -40px;
            left: 50%;
            transform: translateX(-50%);
            content: "";
            background: url("@{cdn}search-icon.png") no-repeat;
            width: 30px;
            height: 30px;
          }
        }
      }
    }
    .l-con {
      width: 76%;
      margin: 60px auto 0;
      box-sizing: border-box;
      text-align: left;
      font-size: 0;
      min-height: 58vh;
    }
    .paging {
      // border-left: #e5e5e5 1px solid;
      height: 100%;
      margin-bottom: 40px;
      transition: all 0.4s ease;
      & /deep/ .p-layout {
        text-align: center;
        margin-top: 10px;
      }
      & /deep/ .p-layout a:not(:last-child) {
        margin: 10px 14px;
        display: inline-block;
        font-weight: 500;
        cursor: pointer;
        user-select: none;
        position: relative;
        transition: color 0.3s;
        color: @theme;
        font-size: 16px;
      }
      & /deep/ .p-layout a:last-child {
        position: relative;
        top: -5px;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -ms-flex-align: center;
        align-items: center;
        height: 22px;
        padding: 0 9px;
      }
      & /deep/ .p-layout a:last-child::before,
      & /deep/ .p-layout a:last-child::after {
        content: "";
        display: inline-block;
        will-change: transform;
        transition: transform 0.3s;
      }

      & /deep/ .p-layout a:not(:last-child).active::after,
      & /deep/ .p-layout a:not(:last-child).active,
      & /deep/ .p-layout a:not(:last-child):hover,
      & /deep/ .p-layout a:not(:last-child):hover::after {
        color: @sub-theme;
        transform: scaleX(1);
        text-align: center;
      }

      & /deep/ .p-layout a:not(:last-child).active {
        position: relative;
        width: 29px;
        font-size: 14px;
        &::after {
          position: absolute;
          bottom: -2px;
          right: 0;
          content: "";
          width: 100%;
          height: 40px;
          background: url("@{cdn}page-active.png") no-repeat center center;
          z-index: -1;
        }
      }
    }
    
  }
}

@media screen and (max-width: 500px) {
  .layout {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .ui-con {
      position: fixed;
      top: 10vh;
      left: 50vw;
      transform: translateX(-50%);
      padding: 0;
      .logo, .search-con{
        width: 50vw;
      }
      .l-con {
        position: fixed;
        top: 25vh;
        left: 5vw;
        width: 93vw;
        height: 55vh;
        margin: 0;
        overflow-y: scroll;
      }
      .no-result {
        margin-top: 150px;
      }
    }
  }
  
}
</style>